// export default IncidentRequest;
import { useAuth } from "context/AuthContext";
import React, { useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Roles } from "types";
import { hasRole } from "utils/helper";
import PageHeader from "../../components/PageHeader";

const tabs = ["All", "New Request", "Appeal"];

const CompliantList: React.FC = () => {
  // const { showTooltip } = useTooltip();
  const { loginData } = useAuth();

  const [activeTab, setActiveTab] = useState("All");
  // const [compliants, setCompliants] = useState<any[]>([]);
  // const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const isRegistrar = hasRole(loginData?.roles, [Roles.registrar]);

  // const fetchData = () => {
  //   setLoading(true);
  //   fetchBailRight()
  //     .then((data) => {
  //       setBailRights(data);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       showTooltip(errorHandler(error));
  //       setLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [activeTab]);

  // const searchTerm = search.trim().toLowerCase();
  // const filtered = compliants.filter((bail) => {
  //   // 1️⃣ — existing text‑search fields
  //   const incident_registration_number =
  //     bail?.incident_registration_number?.toString()?.toLowerCase() || "";
  //   const crime_registration_number =
  //     bail?.crime_registration_number?.toString()?.toLowerCase() || "";
  //   const status = bail?.status?.toString()?.toLowerCase() || "";
  //   const bail_type = bail?.bail_type?.toString()?.toLowerCase() || "";

  //   const matchesText =
  //     incident_registration_number.includes(searchTerm) ||
  //     crime_registration_number.includes(searchTerm) ||
  //     status.includes(searchTerm) ||
  //     bail_type.includes(searchTerm);

  //   return matchesText;
  // });

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      <PageHeader
        title="Compliant Request"
        icon={FaBriefcase}
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        rightContent={
          <>
            {isRegistrar && (
              <button
                onClick={() => navigate("/bail-right-request")}
                className="px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
              >
                Create a new Compliant
              </button>
            )}
          </>
        }
      />

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="overflow-hidden bg-white shadow rounded-xl">
          <table className="w-full text-sm border-collapse">
            <thead className="text-white bg-black">
              <tr>
                <th colSpan={7} className="p-4" rounded-t-lg>
                  <div className="flex items-center justify-between">
                    {/* Left: Back + Title */}
                    <div className="flex items-center gap-2 text-lg font-semibold">
                      <button
                        onClick={() => navigate(-1)}
                        className="text-white hover:text-gray-300"
                        title="Go Back"
                      >
                        ◀️
                      </button>
                      <span>Request Table</span>
                    </div>

                    {/* Right: Search Box */}
                    <div className="relative w-80">
                      <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                        🔍
                      </span>
                      <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                      />
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                <th className="p-3 text-left">Compliant Req</th>
                <th className="p-3 text-left">Assigned Mgt.</th>
                <th className="p-3 text-left">Assigned Date</th>
                <th className="p-3 text-left">Types</th>
                <th className="p-3 text-left">Phone Number</th>
                <th className="p-3 text-left" rounded-tr-lg>
                  View Action
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {filtered.map((data, idx) => (
                <tr
                  key={idx}
                  className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                >
                  <td className="p-3 font-[500] font-[Poppins]">
                    {data?.suspect_fullname ||
                      data?.suspect_info?.first_name +
                        " " +
                        data?.suspect_info?.middle_name +
                        " " +
                        data?.suspect_info?.last_name}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {data?.court_registration_number}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {data.court_name}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]"></td>
                  <td className="p-3 font-[500] font-[inter]"></td>

                  <td className="p-3 font-[500] font-[Poppins] flex flex-row gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        navigate("/bail-right/" + data?.uu_id + "/");
                      }}
                      className="px-4 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300"
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))} */}
              {/* {compliants.length === 0 && (
                <tr>
                  <td colSpan={6} className="p-4 text-center text-gray-500">
                    No compliant found.
                  </td>
                </tr>
              )} */}
            </tbody>
          </table>
        </div>
      </div>

      {/* {isOpenFurtherInvestigation && selectedFile && (
        <FurtherInvestigationForm
          isOpen={isOpenFurtherInvestigation}
          action={"Edit"}
          file={undefined}
          furtherInvestigation={selectedFile}
          onClose={(refetch) => {
            setIsOpenFurtherInvestigation(false);

            if (refetch) {
              fetchData();
            }
          }}
        />
      )} */}
    </div>
  );
};

export default CompliantList;
